/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Route, Redirect } from "react-router-dom";
import _ from "lodash";
import { Auth } from "aws-amplify";

const PrivateRoute = ({ component: Component, componentProps, ...rest }) => {
  const [dataIsReady, setDataIsReady] = useState(false);
  const [cognitoUser, setCognitoUser] = useState({});

  useEffect(() => {
    Auth.currentAuthenticatedUser()
      .then(user => {
        setCognitoUser(user);
        setDataIsReady(true);
      })
      .catch(() => {
        setDataIsReady(true);
      });
  }, [Component]);

  return dataIsReady === true ? (
    <Route
      {...rest}
      render={props => {
        const mergedProps = { ...props, ...componentProps };
        return !_.isEmpty(cognitoUser) ? (
          <Component {...mergedProps} />
        ) : (
          <Redirect to={{ pathname: "/login" }} />
        );
      }}
    />
  ) : null;
};

export default PrivateRoute;
